import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    private readonly supportedLanguages: { [key: string]: string } = {
        'tr': 'tr.json',
        'sv': 'sv.json',
        'pt': 'pt.json',
        'pl': 'pl.json',
        'nl': 'nl.json',
        'nb': 'nb.json',
        'it': 'it.json',
        'fr': 'fr.json',
        'fi': 'fi.json',
        'es': 'es.json',
        'en': 'en.json',     // Default to US English for "en"
        'en-us': 'en.json',  // Explicit mapping for US English
        'en-gb': 'en-gb.json',
        'de': 'de.json',
        'hu': 'hu.json',
        'zh-cn': 'zh-CHS.json', // Simplified Chinese
        'zh-sg': 'zh-CHS.json', // Simplified Chinese (Singapore)
        'zh-tw': 'zh-CHT.json', // Traditional Chinese
        'zh-hk': 'zh-CHT.json', // Traditional Chinese (Hong Kong)
        'zh-mo': 'zh-CHT.json', // Traditional Chinese (Macau)
        'ja': 'ja.json',
        'ko': 'ko.json'        
    };

    private readonly fallbackLanguage: string = 'en.json';

    getBrowserLanguage() {
        return navigator.language || navigator['userLanguage']; // Fallback for older browsers
    }

    getBrowserLanguages() {
        return navigator.languages || [this.getBrowserLanguage()];
    }

    /**
     * Gets the appropriate translation file based on the browser's language.
     * Falls back to `en.json` if no suitable match is found.
     */
    getTranslationFile(): string {
        const browserLanguage = this.getBrowserLanguage().toLowerCase(); // e.g., 'en-us', 'fr', etc.
        
        // Check for an exact match
        if (this.supportedLanguages[browserLanguage]) {
            return this.supportedLanguages[browserLanguage];
        }

        // Check for a generic match (e.g., 'en' from 'en-US')
        const genericLanguage = browserLanguage.split('-')[0];
        if (this.supportedLanguages[genericLanguage]) {
            return this.supportedLanguages[genericLanguage];
        }

        // Default to the fallback language
        return this.fallbackLanguage;
    }
}